import { NativeModules } from 'react-native';
const { RNSecLib } = NativeModules;
export default class NetworkLogger {
	constructor(url, method, requestHeaders) {
		this.url = url;
		this.method = method;
		this.requestHeaders = requestHeaders;
	}
	logResponse = (responseCode, responseHeaders, errorDescription) => {
		RNSecLib.requestMetrics(
			this.url,
			this.method,
			this.requestHeaders,
			responseCode,
			responseHeaders,
			errorDescription,
		);
	};
}
